<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="bg-white flex flex-col justify-center items-stretch">
    <div
      class="flex-col box-border overflow-hidden relative flex h-[100vh] w-full justify-start pr-0 pr-md-16 items-start max-md:max-w-full max-md:pr-0"
    >
      <img
        src="@/assets/images/landing-broker.jpeg"
        class="absolute h-full w-full object-cover object-center inset-0"
      />
      <div
        class="backdrop-blur-[21px] box-border bg-black bg-opacity-70 flex w-[610px] h-[100vh] overflow-auto hide-scrollbar max-w-full flex-col justify-center items-center px-16 max-md:px-5"
      >
        <div
          class="flex w-[372px] box-border max-w-full flex-col min-h-full items-center"
        >
          <img
            loading="lazy"
            src="@/assets/images/logo-vertical.svg"
            class="aspect-[2.14] object-contain object-center w-[214px] min-w-[210px] min-h-[180px] mt-6 md:mt-9 max-md:mb-8 overflow-hidden max-w-full"
          />
          <div
            class="text-white text-center text-2xl font-medium w-full max-md:mt-10"
            :class="[type == 'userLogin' ? ' mt-16 ' : ' mt-14 ']"
          >
            <span class="text-white">Welcome to {{ name }}.</span><br /><span
              class="text-base text-white"
              >Please sign in to continue</span
            >
          </div>
          <div class="w-full flex flex-col justify-center">
            <Form
              v-show="type == 'userLogin'"
              @submit="onSubmit"
              class="w-full mt-16"
              ref="formRefLogin"
              :validation-schema="
                force ? FormValidationSchemaForce : FormValidationSchema
              "
            >
              <!-- <div class="w-full mt-16"> -->
              <div class="mt-2 w-full relative">
                <div class="row-top">
                  <ErrorMessage
                    name="email"
                    class="error-message text-red-200 bg-transparent top-auto bottom-0 -mb-8 text-sm"
                  />
                </div>
                <Field
                  name="email"
                  id="email"
                  placeholder="Enter your email please"
                  autocomplete="email"
                  type="email"
                  class="block w-full form-input rounded-md border-0 text-[16px] py-1.5 text-gray-100 text-start placeholder:text-gray-400 focus:ring-0 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
              <div
                class="bg-white opacity-40 self-stretch shrink-0 h-px mt-1"
              ></div>
              <!-- </div> -->
              <btnAnimation
                :isIcon="true"
                :height="72"
                class="mt-12 max-md:mt-10"
                @click="sendMail"
              ></btnAnimation>
            </Form>
            <Form
              v-show="type !== 'userLogin'"
              @submit="onSubmit"
              class="w-full mt-16"
              ref="formRefLogin2"
              :validation-schema="FormValidationSchemaBroker"
            >
              <div class="mt-2 w-full relative">
                <div class="row-top">
                  <ErrorMessage
                    name="email"
                    class="error-message text-red-200 bg-transparent top-auto bottom-0 -mb-8 text-sm"
                  />
                </div>
                <Field
                  name="email"
                  id="email2"
                  placeholder="Enter your email please"
                  autocomplete="email"
                  type="text"
                  class="block w-full form-input rounded-md border-0 text-[16px] py-1.5 text-gray-100 text-start placeholder:text-gray-400 focus:ring-0 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
              <div
                class="bg-white opacity-40 self-stretch shrink-0 h-px mt-1"
              ></div>
              <div class="mt-2 w-full relative">
                <div class="row-top">
                  <ErrorMessage
                    name="password"
                    class="error-message text-red-200 bg-transparent top-auto bottom-0 -mb-8 text-sm"
                  />
                </div>
                <Field
                  name="password"
                  id="password"
                  placeholder="Enter your password please"
                  autocomplete="password"
                  type="password"
                  class="block w-full form-input rounded-md border-0 text-[16px] py-1.5 text-gray-100 text-start placeholder:text-gray-400 focus:ring-0 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>

              <div
                class="bg-white opacity-40 self-stretch shrink-0 h-px mt-1"
              ></div>
              <btnAnimation
                :isIcon="true"
                :height="72"
                class="mt-12 max-md:mt-10"
                @click="sendMailBroker"
              ></btnAnimation>
            </Form>
            <div class="mt-4 mb-5">
              <p class="text-white w-fit mx-auto max-md:mb-3">
                <span v-if="type !== 'userLogin'"> Not a Broker? </span>
                <span v-else> Registered Broker? </span>
                <span
                  class="underline cursor-pointer"
                  @click="
                    type = type == 'userLogin' ? 'brokerLogin' : 'userLogin'
                  "
                >
                  Sign in here
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import btnAnimation from "@/components/base/common/btnAnimation.vue";
import { onMounted, ref } from "vue";
import { useCookies } from "vue3-cookies";
import { login } from "@/services/axios/login.service.js";
import { floors } from "@/services/axios/floors.service.js";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { useRouter } from "vue-router";
import { useStore } from "@/store/loading.js";
import { useFloorplan } from "@/store/floor.js";
import axios from "axios";
import { showToast } from "@/util/toast";

const store = useStore();
const router = useRouter();
const { cookies } = useCookies();
const formRefLogin = ref(null);
const formRefLogin2 = ref(null);
const type = ref("userLogin");
const name = ref(process.env.VUE_APP_PROJECT_NAME);

const onSubmit = () => {
  console.log("onSubmit");
};
const FormValidationSchema = yup.object({
  email: yup.string().email(),
});

const FormValidationSchemaForce = yup.object({
  email: yup
    .string()
    .required("Email is a required field")
    .email("Email must be a valid email"),
});

const FormValidationSchemaBroker = yup.object({
  email: yup.string().required("Email is a required field"),
  password: yup.string().required("Password is a required field"),
});

const force = ref(false);
onMounted(() => {
  if (process.env.VUE_APP_MANDATORY_LOGIN) force.value = true;
});

const sendMail = async () => {
  try {
    if (force.value) {
      const valid = await validation();
      if (valid) {
        const mail = formRefLogin.value.getValues();
        store.isLoading = true;
        const { data } = await login(mail);
        if (data.token) {
          // Store data for GA4 eventv-if="model?.document?.file"
          localStorage.setItem("email", mail.email);
          localStorage.setItem("user_type", "Customer"); // Customer or Broker
          localStorage.setItem("status", data.status);
          localStorage.setItem("organization_id", data.organization);
          localStorage.setItem("project_id", data.project);
          cookies.set("token", data.token);
          store.accessToken = data.token;
          store.isAgent = false;
          const res = await floors();
          const floorplan = useFloorplan();
          const compare = (a, b) => {
            return a.area - b.area;
          };
          res.data.sort(compare);
          floorplan.addFloorplan(res.data);
          router.push({ name: "floorplans", query: { full_3d: true } });
        }
      } else {
        console.error("error");
      }
    } else {
      const data = formRefLogin.value.getValues();
      if (data.email) {
        const valid = await validation();
        if (valid) router.push({ name: "floorplans" });
      } else {
        router.push({ name: "floorplans" });
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const sendMailBroker = async () => {
  const projectId = process.env.VUE_APP_CLIENT_ID;
  try {
    const valid = await validationBroker();
    if (valid) {
      const mail = formRefLogin2.value.getValues();
      store.isLoading = true;
      const { data } = await loginBroker(mail);
      if (data.token) {
        localStorage.setItem("email", mail.email);
        localStorage.setItem("user_type", "Broker"); // Customer or Broker
        localStorage.setItem("status", "returning");
        localStorage.setItem("organization_id", data.organization);
        localStorage.setItem("project_id", projectId);
        cookies.set("token", data.token.access_token);
        store.accessToken = data.token.access_token;
        store.user = data.user;
        store.isAgent = true;
        store.isLoading = false;
        const res = await floors();
        const floorplan = useFloorplan();
        const compare = (a, b) => {
          return a.area - b.area;
        };
        res.data.sort(compare);
        floorplan.addFloorplan(res.data);
        router.push({ name: "floorplans", query: { full_3d: true } });
      }
    } else {
      console.error("error");
    }
  } catch (error) {
    console.error("error", error);
  }
};

const loginBroker = async (mail) => {
  try {
    const data = await axios({
      method: "POST",
      headers: {
        "X-CLIENT-ID": +process.env.VUE_APP_CLIENT_ID,
        "X-CLIENT-SECRET": process.env.VUE_APP_NOT_SECRET_CODE,
      },
      url: process.env.VUE_APP_BASE_URL_LOGIN + "agent-api/v1/login",
      data: mail,
    });
    return data.data;
  } catch (error) {
    store.isLoading = false;
    showToast({
      message:
        error?.response?.data?.message ||
        error?.response?.data?.result?.message ||
        error?.response?.data?.data?.message,
      type: "error",
    });
  }
};

const validation = async () => {
  try {
    if (!formRefLogin.value) {
      throw false;
    }
    const v = await formRefLogin.value.validate();
    if (!v.valid) {
      throw false;
    }
    return true;
  } catch (error) {
    console.error("Error submitting form:", error);
  }
};

const validationBroker = async () => {
  try {
    if (!formRefLogin2.value) {
      throw false;
    }
    const v = await formRefLogin2.value.validate();
    if (!v.valid) {
      throw false;
    }
    return true;
  } catch (error) {
    console.error("Error submitting form:", error);
  }
};
</script>
